import React from 'react';

interface TestFooterProps {
  appName?: string;
  version?: string;
}

const TestFooter: React.FC<TestFooterProps> = ({ 
  appName = "AnyGRC", 
  version = "v2.0" 
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      gap: '12px',
      height: '100%',
      fontSize: '12px',
      color: '#d1d5db'
    }}>
      <span>© 2025 {appName}</span>
      <span>•</span>
      <span>🏗️ Layout System {version}</span>
      <span>•</span>
      <span>📍 Footer Component</span>
    </div>
  );
};

export default TestFooter;